import { CommonModule, DatePipe } from "@angular/common";
import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatRippleModule } from "@angular/material/core";
import { ToastrService } from "ngx-toastr";
import { Int_ExcelExportAction, Int_Excel_Export_File_Config } from "../../models/components";

@Component({
    selector: "mobi-office-lib-excel-export-drawer",
    imports: [CommonModule, MatRippleModule, FormsModule],
    templateUrl: "./excel-export-drawer.component.html",
    styleUrl: "./excel-export-drawer.component.scss"
})
export class ExcelExportDrawerComponent implements OnChanges {
  private readonly toastr = inject(ToastrService);
  private readonly datePipe = inject(DatePipe);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["excelExportOptions"]?.currentValue) {
      this.excelExportOptions = JSON.parse(JSON.stringify(this.excelExportOptions));
    }
  }

  @Input({ required: true }) excelExportOptions: Int_ExcelExportAction = {
    HEADING: "",
    DATA: [],
    FIELDS: [],
  };
  @Input({ required: true }) fileName: string = "";
  @Output() excelExportEmitter = new EventEmitter<Int_Excel_Export_File_Config>();
  /**
   * Emitter action
   * onExportExcel($event: Int_Excel_Export_File_Config) {
      const data = this.functionalityService.transformExcelItems(this.excelExportOptions.DATA, $event.columns || []);
      $event.items = data;
      if ($event.type === "csv") this.functionalityService.csvExport($event);
      else this.functionalityService.xlsxExport($event);
     }
   */

  isAllSelected = false;
  isCsv: boolean = false;
  isXlsx: boolean = true;

  get getSelectedFieldCount() {
    return this.excelExportOptions.FIELDS.filter(el => el.IsSelected).length;
  }

  onExport() {
    if (!this.isCsv && !this.isXlsx) {
      this.toastr.info("Please Select File Type");
      return;
    }

    if (!this.getSelectedFieldCount) {
      this.toastr.info("Please Select Fields");
      return;
    }

    this.isCsv ? this.onCsvExport() : this.onXlsxExport();
  }

  private onXlsxExport() {
    const fileConfig = this.getExportConfig();
    fileConfig.type = "excel";
    this.excelExportEmitter.emit(fileConfig);
  }

  private onCsvExport() {
    const fileConfig = this.getExportConfig();
    fileConfig.type = "csv";
    this.excelExportEmitter.emit(fileConfig);
  }

  private getExportConfig(): Int_Excel_Export_File_Config {
    return {
      columns: this.excelExportOptions.FIELDS.filter(el => el.IsSelected),
      fileName: `${this.fileName?.split(" ").join("_")}-${this.datePipe.transform(new Date(), "dd-MM-yyyy, h:mm")}`,
      items: [],
    };
  }

  onSelectAll() {
    this.excelExportOptions.FIELDS.map(el => {
      el.IsSelected = this.isAllSelected;
    });
  }
}
